<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>Carnet d'adresses</mat-card-title>
        <div class="mat-card-header-buttons small">
            <mat-form-field class="basic-button form-item without-error" appearance="outline">
                <mat-label>Carnet d'adresse</mat-label>
                <mat-select (selectionChange)="contactTypeChange($event.value)" [(value)]="contactTypeSelected" matTooltip="Sélection du carnet d'adresses">
                    @for (contactType of contactsType | keyvalue; track contactType) {
                        <mat-option [value]="contactType.key">
                            {{ contactsTypeLabels.get(contactType.key) }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="search-div">
                <form [formGroup]="searchFilterHandler.filtersForm" novalidate class="small">
                    <mat-form-field appearance="outline" class="without-error">
                        <fa-icon matPrefix class="mat-accent search-icon" [icon]="searchIcon"></fa-icon>
                        <mat-label>Rechercher</mat-label>
                        <input matInput formControlName="search" />
                    </mat-form-field>
                    <button
                        mat-mini-fab
                        class="basic-button button-erase-filter small"
                        aria-label="Réinitialiser"
                        matTooltip="Réinitialiser la recherche"
                        matTooltipPosition="below"
                        (click)="$event.stopPropagation(); searchFilterHandler.resetColumnFilter('search')">
                        <fa-icon [icon]="resetSearchIcon"></fa-icon>
                    </button>
                </form>
            </div>

            <div class="contacts-table-container">
                <table matSort (matSortChange)="onSorting($event)">
                    <tr class="header-row">
                        @for (column of contactsTableColumnsDefinitions; track column) {
                            <th>
                                <span class="sort-icon" [mat-sort-header]="column.columnName">{{ column.headerText }}</span>
                            </th>
                        }
                    </tr>
                    @if (contactTypeSelected === contactsType.Customer) {
                        @for (customer of filteredCustomers; track customer; let index = $index) {
                            <tr class="data-row" [class.selected]="isSelected(index)" (click)="onMouseClick($event, index)" (dblclick)="addToAddress()">
                                <td class="no-select">{{ customer.code }}</td>
                                <td class="no-select">{{ customer.name }}</td>
                                @if (data.dataType === ContactDataType.Email) {
                                    <td class="no-select">{{ customer.email }}</td>
                                } @else if (data.dataType === ContactDataType.Sms) {
                                    <td class="no-select">{{ customer.mobileNumber }}</td>
                                }
                                <td class="no-select">{{ customer.siret }}</td>
                            </tr>
                        }
                    }
                    @if (contactTypeSelected === contactsType.User) {
                        @for (user of filteredUsers; track user; let index = $index) {
                            <tr class="data-row" [class.selected]="isSelected(index)" (click)="onMouseClick($event, index)" (dblclick)="addToAddress()">
                                <td class="no-select">{{ user.lastName }}</td>
                                <td class="no-select">{{ user.firstName }}</td>
                                @if (data.dataType === ContactDataType.Email) {
                                    <td class="no-select">{{ user.email }}</td>
                                } @else if (data.dataType === ContactDataType.Sms) {
                                    <td class="no-select">{{ user.mobileNumber }}</td>
                                }
                            </tr>
                        }
                    }
                    @if (contactTypeSelected === contactsType.Contact) {
                        @for (contact of filteredContacts; track contact; let index = $index) {
                            <tr class="data-row" [class.selected]="isSelected(index)" (click)="onMouseClick($event, index)" (dblclick)="addToAddress()">
                                <td class="no-select">{{ contact.lastName }}</td>
                                <td class="no-select">{{ contact.firstName }}</td>
                                @if (data.dataType === ContactDataType.Email) {
                                    <td class="no-select">{{ contact.email }}</td>
                                } @else if (data.dataType === ContactDataType.Sms) {
                                    <td class="no-select">{{ contact.mobileNumber }}</td>
                                }
                                <td class="no-select">{{ contact.companyName }}</td>
                            </tr>
                        }
                    }
                </table>
            </div>

            <div class="add-address-div">
                <div class="add-address-info-div form-item">
                    <mat-label class="chips-container-label">Destinataires</mat-label>
                    <div class="chips-container">
                        <mat-chip-listbox multiple class="compact">
                            @for (item of data.toAddresses; track item) {
                                <mat-chip-option selectable="false" removable="true" (removed)="removeToAddress(item)">
                                    {{ item }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            }
                        </mat-chip-listbox>
                    </div>
                    <button
                        mat-mini-fab
                        class="basic-button small"
                        [attr.aria-label]="
                            data.dataType === ContactDataType.Email ? 'Ajouter l\'adresse e-mail aux destinataires' : 'Ajouter le numéro de mobile aux destinataires'
                        "
                        [matTooltip]="data.dataType === ContactDataType.Email ? 'Ajouter l\'adresse e-mail aux destinataires' : 'Ajouter le numéro de mobile aux destinataires'"
                        matTooltipPosition="below"
                        (click)="addToAddress()">
                        <fa-icon [icon]="addIcon"></fa-icon>
                    </button>
                </div>

                @if (data.dataType === ContactDataType.Email) {
                    <div class="add-address-info-div form-item">
                        <mat-label class="chips-container-label">Copies conformes</mat-label>
                        <div class="chips-container">
                            <mat-chip-listbox multiple class="compact">
                                @for (item of data.ccAddresses; track item) {
                                    <mat-chip-option selectable="false" removable="true" (removed)="removeCcAddress(item)">
                                        {{ item }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        </div>
                        <button
                            mat-mini-fab
                            class="basic-button small"
                            aria-label="Ajouter l'adresse e-mail aux copies conformes"
                            matTooltip="Ajouter l'adresse e-mail aux copies conformes"
                            matTooltipPosition="below"
                            (click)="addCcAddress()">
                            <fa-icon [icon]="addIcon"></fa-icon>
                        </button>
                    </div>
                    <div class="add-address-info-div form-item">
                        <mat-label class="chips-container-label">Copies conformes cachées</mat-label>
                        <div class="chips-container">
                            <mat-chip-listbox multiple class="compact">
                                @for (item of data.cciAddresses; track item) {
                                    <mat-chip-option selectable="false" removable="true" (removed)="removeCciAddress(item)">
                                        {{ item }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        </div>
                        <button
                            mat-mini-fab
                            class="basic-button small"
                            aria-label="Ajouter l'adresse e-mail aux copies conformes cachées"
                            matTooltip="Ajouter l'adresse e-mail aux copies conformes cachées"
                            matTooltipPosition="below"
                            (click)="addCciAddress()">
                            <fa-icon [icon]="addIcon"></fa-icon>
                        </button>
                    </div>
                }
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="false">Valider</button>
    </mat-card-actions>
</mat-card>
